import React, { useState, useEffect } from 'react';

import Navbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footers/Footer.js";

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BASE_URL from 'components/BaseUrl/apiConfig';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';
import UserIcon from 'assets/img/icons-user.png'

export default function Profile() {

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem('userData')) {
      // Redirect to the login page
      history.push('/login');
    }
  }, [history]);


  // get userId from local storage
  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }

  useEffect(() => {
    // fetch user data from the API
    fetch(`${BASE_URL}/api/Users/GetUserById?userId=${userId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log('API Response:', data);
        setUserData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
        setError('Error fetching user data');
        setLoading(false);
      });
  }, []); // Empty dependency array ensures the effect runs only once on component mount



  const ClickUpdateButton = () => {
    history.push('/updateProfile');
  };



  return (
    <>
      <Navbar transparent />
      <main className="profile-page">
        <BlockUiOverlay visible={loading} />
        <section className="relative block h-350-px">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80')",
            }}
          >
            <span
              id="blackOverlay"
              className="w-full h-full absolute opacity-50 bg-black"
            ></span>
          </div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style={{ transform: "translateZ(0)" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </section>
        <section className="relative py-16 bg-blueGray-200">

          <div className="container mx-auto px-4">
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="px-6">
                <div className="flex flex-wrap justify-center">
                  <div className="w-full lg:w-3/12 px-4 lg:order-2 flex justify-center">
                    <div className="relative">
                      {userData && userData.image ? (
                        <img
                          alt="User Image"
                          src={userData.image}
                          className="shadow-xl rounded-full  align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                          style={{ height: '150px', width: '150px' }}
                        />
                      ) : (
                        <img
                          alt="User Image"
                          src={UserIcon}
                          className="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                          style={{ height: '150px', width: '150px' }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="w-full lg:w-5/12 px-4 lg:order-3 lg:text-right lg:self-center">
                    <div className="py-6 px-3 mt-20 sm:mt-0">
                      <button
                        className="bg-lightBlue-500 active:bg-lightBlue-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        style={{ float: "inline-end" }}
                        onClick={ClickUpdateButton}
                      >
                        Update
                      </button>
                    </div>
                  </div>

                </div>

                <div className="mt-10 flex justify-center">
                  {userData ? (
                    <div className="text-left">
                      <h3 className="text-4xl font-semibold leading-normal mb-2 text-blueGray-700 mb-2">
                        {userData.fullName}
                      </h3>
                      <div className="flex flex-col">
                        <div className="flex items-center mb-2">
                          <div className="flex mr-2">
                            <i className="fas fa-user-tie text-lg text-blueGray-400 mr-2" title="User Name"></i>
                          </div>
                          <div className="text-lightBlue-600">{userData.userName}</div>
                        </div>
                        <div className="flex items-center mb-2">
                          <div className="flex mr-2">
                            <i className="fas fa-envelope text-lg text-blueGray-400 mr-2" title="Email Address"></i>
                          </div>
                          <div className="text-lightBlue-600 ">{userData.emailId}</div>
                        </div>
                        <div className="flex items-center mb-2">
                          <div className="flex mr-2">
                            <i className="fas fa-mobile-alt text-lg text-blueGray-400 mr-2" title="Mobile Number"></i>
                          </div>
                          <div className="text-lightBlue-600 ml-1">{userData.contact}</div>
                        </div>
                        <div className="flex items-center">
                          <div className="flex mr-2">
                            <i className="fas fa-building text-lg text-blueGray-400 mr-2" title="Organization Name"></i>
                          </div>
                          <div className="text-lightBlue-600">{userData.organizationName}</div>
                        </div>
                      </div>
                    </div>



                  ) : (
                    <p></p>
                  )}
                </div>





                <div className="mt-10 py-5 border-t border-blueGray-200 text-center">
                  <div className="flex flex-wrap justify-center">
                    <div className="w-full lg:w-9/12 px-4">
                      <p className="mb-4 text-lg leading-relaxed text-blueGray-700">

                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
